<template>
  <BaseModal
    v-model="dialogVisible"
    title="Starting a new recording?"
    width="640px"
    header-background-color="#FCEAEA"
    header-text-color="#C23934"
    description="Starting a new recording will replace the existing generated notes from the previous recording. This action cannot be undone."
    @close="handleClose"
  >
    <template #title-icon>
      <MicIcon class="w-6 h-6" fill="#C23934" stroke="#C23934" />
    </template>

    <template #footer>
      <div class="modal-actions">
        <NewButton
          type="normal"
          color-type="red-stroke"
          @click="handleClose"
        >
          Cancel
        </NewButton>
        <NewButton
          type="normal"
          color-type="red"
          @click="handleConfirm"
        >
          Starting new recording
        </NewButton>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import { computed } from "vue";
import BaseModal from "./BaseModal.vue";
import NewButton from "@/NewLibrary/Button.vue";
import MicIcon from "./MicIcon.vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:visible", "confirm", "cancel"]);

const dialogVisible = computed({
  get() {
    return props.visible;
  },
  set(value) {
    emit("update:visible", value);
  },
});

const handleClose = () => {
  emit("update:visible", false);
  emit("cancel");
};

const handleConfirm = () => {
  emit("update:visible", false);
  emit("confirm");
};
</script>

<style scoped>
.modal-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
}
</style>
